import Command from '@src/plugins/ckeditor5-core/src/command';
import first from '@src/plugins/ckeditor5-utils/src/first';
export default class RemoveIndentTextCommand extends Command {
	refresh() {
		const editor = this.editor;
		const model = editor.model;

		const block = first( model.document.selection.getSelectedBlocks() );

		if ( !block || !model.schema.checkAttribute( block, 'indentText' ) ) {
			this.isEnabled = false;
			return;
		}

		this.isEnabled = !!block.getAttribute( 'indentText' );
	}
	execute() {
		const model = this.editor.model;
		const blocksToChange = getBlocksToChange( model );
		model.change( writer => {
			for ( const block of blocksToChange ) {
				const currentIndent = block.getAttribute( 'indentText' );
				if ( currentIndent ) {
					writer.removeAttribute( 'indentText', block );
				}
			}
		} );
	}
}
function getBlocksToChange( model ) {
	const selection = model.document.selection;
	const schema = model.schema;
	const blocksInSelection = Array.from( selection.getSelectedBlocks() );
	return blocksInSelection.filter( block => schema.checkAttribute( block, 'indentText' ) );
}
